import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Clock from "../components/Clock";
import Footer from "../components/footer";
import CustomToastContainer from "../../Common/CustomToastContainer";
import { createGlobalStyle } from "styled-components";
import { useNavigate } from "react-router-dom";
import { getData, postData } from "../../Common/api";
import { DAppClient, NetworkType } from "@airgap/beacon-sdk";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import { nftItems } from "../../store/selectors";
import { createHistory } from "../../Common/createHistory";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const generateAvatarurl = process.env.REACT_APP_GENERATE_AVATAR_URL;
const tzktendpoint = process.env.REACT_APP_TZKT_API_ENDPOINT;

const GlobalStyles = createGlobalStyle`
  .logout{
    display: flex;
    align-items: center;
  }
`;
const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL); // or use a custom RPC endpoint

const wallet = new BeaconWallet({
  name: "ArtCollect",
  preferredNetwork: NetworkType.GHOSTNET, // or GHOSTNET
});

tezos.setWalletProvider(wallet);
const Createpage = () => {
  const toastRef = useRef();
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [showSellModal, setShowSellModal] = useState(false);
  const [file, setFile] = React.useState(null);
  const [ipfsUrl, setIpfsUrl] = React.useState(""); // IPFS URL from upload
  const [publicUrl, setPublicUrl] = React.useState(""); // public gateway URL
  const [mimeType, setMimeType] = React.useState("");
  const [sellPrice, setSellPrice] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [userNFTs, setUserNFTs] = useState([]);
  const [userAddress, setUserAddress] = useState();
  const [walletAddress, setWalletAddress] = useState("");
  const [showMOdal, setShowMOdal] = useState(false);
  const [hasClosedModal, setHasClosedModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSellOption, setShowSellOption] = useState(false);
  const [creatorSales, setCreatorSales] = useState(0);
  const [auctionStartTime, setAuctionStartTime] = useState("");
  const [auctionEndTime, setAuctionEndTime] = useState("");
  const [editionCount, setEditionCount] = useState(1); // New state for edition count
  const [auctionDuration, setAuctionDuration] = useState(1); // New state for auction duration in days
  const [showAuctionOption, setShowAuctionOption] = useState(false); // New state for auction option visibility
  const [auctionValidation, setAuctionValidation] = useState({
    isValid: true,
    message: "",
  });
  const [formData, setFormData] = useState({
    item_title: "",
    item_desc: "",
    item_price: "0.0",
    item_royalties: "10",
    item_likes: "0",
    open_to_offers: true,
    open_to_sell: false,
    open_to_auction: false, // New field for auction
    minimum_bid: "0.5", // New field for auction
    edition_type: "fixed", // New field for edition type
    total_supply: "", // New field for total supply (only for fixed editions)
    minted_count: 0, // New field to track the number of editions minted
    open_until: "", // New field for open until (only for open editions)
  });

  const [showBurnSellModal, setShowBurnSellModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setUserAddress(storedAddress);
      fetchUserNFTData(storedAddress);
      setWalletAddress(storedAddress);
      generateAvatar(storedAddress);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      axios
        .get(`${domainpath}/api/sales-count/${storedAddress}`)
        .then((res) => {
          // setShowAuctionOption(true);
          setCreatorSales(res.data.sales_count);
          if (res.data.sales_count >= 10) {
            setShowAuctionOption(true);
            setShowSellOption(true);
            setShowBurnSellModal(false);
            setLoading(false);
          } else if (res.data.sales_count >= 0) {
            setShowBurnSellModal(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error("Error fetching sales:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const generateAvatar = (walletAddress) => {
    setProfileImage(`${generateAvatarurl}/${walletAddress}.png?size=200x200`);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle mutually exclusive checkboxes
    if (type === "checkbox") {
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          open_to_offers: name === "open_to_offers" ? true : false,
          open_to_sell: name === "open_to_sell" ? true : false,
          open_to_auction: name === "open_to_auction" ? true : false,
        }));
      } else {
        // If unchecking, only update the specific one that was unchecked
        setFormData((prevData) => ({
          ...prevData,
          [name]: false,
        }));
      }
      // Reset auction validation when toggling auction option
      if (name === "open_to_auction" && !checked) {
        setAuctionValidation({ isValid: true, message: "" });
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleAuctionTimeChange = (e, type) => {
    const value = e.target.value;
    if (type === "start") {
      setAuctionStartTime(value);
    } else {
      setAuctionEndTime(value);
    }

    // Validate times when both are set
    if (auctionStartTime && auctionEndTime) {
      validateAuctionTimes();
    }
  };

  const validateAuctionTimes = () => {
    if (!auctionStartTime || !auctionEndTime) {
      setAuctionValidation({
        isValid: false,
        message: "Both start and end times are required",
      });
      return false;
    }

    const start = new Date(auctionStartTime);
    const end = new Date(auctionEndTime);

    if (start >= end) {
      setAuctionValidation({
        isValid: false,
        message: "End time must be after start time",
      });
      return false;
    }

    setAuctionValidation({ isValid: true, message: "" });
    return true;
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/webp",
      "image/gif",
      "video/mp4",
      "audio/mpeg",
    ];
    const maxSize = 500 * 1024 * 1024; // 200MB

    if (!allowedTypes.includes(selectedFile.type)) {
      alert("Unsupported file type.");
      return;
    }

    if (selectedFile.size > maxSize) {
      alert("File is too large. Max 500MB allowed.");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await fetch(`${domainpath}/api/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Upload successful:", data);
        setIpfsUrl(data.ipfsUrl); // saved here to use later
        setPublicUrl(data.publicUrl);
        setMimeType(data.mimeType);
        setFile(selectedFile);
        setLoading(false);
        setPreviewUrl(URL.createObjectURL(selectedFile));
      } else {
        console.error("Upload failed:", data.error || data.details);
      }
    } catch (error) {
      console.error("Upload error:", error.message);
    }
  };

  const handleTagKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && tagInput.trim()) {
      e.preventDefault();
      const newTag = tagInput.trim().replace(/,$/, "");
      if (!tags.includes(newTag) && newTag.length > 0) {
        setTags([...tags, newTag]);
      }
      setTagInput("");
    }
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, i) => i !== indexToRemove));
  };

  const handleBurnNFT = async (nftId) => {
    setLoading(true);
    try {
      const response = await postData(`/api/art/burn-nft`, {
        nftId: nftId,
        walletAddress: walletAddress,
      });

      if (response.success) {
        toastRef.current.addToast("NFT burned successfully!", "success");
        setUserNFTs([]);
        setShowBurnSellModal(false);
        setHasClosedModal(false);
        setLoading(false);
      } else {
        toastRef.current.addToast(
          response.data.error || "Failed to burn NFT.",
          "error"
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("Error burning NFT:", error);
      toastRef.current.addToast(
        "An error occurred while burning the NFT.",
        "error"
      );
      setLoading(false);
    }
  };

  const fetchUserNFTData = async () => {
    try {
      const data = await getData("/api/nfts-created");
      if (data.success) {
        setUserNFTs(data.nfts);
        setHasClosedModal(false);
        //setShowBurnSellModal(true);
        setHasClosedModal(false);
      }
    } catch (error) {
      console.error("Error fetching NFT data:", error);
    }
  };

  // const handleUpload = async () => {
  //   if (!walletAddress)
  //     return toastRef.current.addToast(
  //       "Please connect your Temple Wallet first.",
  //       "warning"
  //     );
  //   if (!file)
  //     return toastRef.current.addToast("Please select a file.", "warning");
  //   if (!formData.item_title)
  //     return toastRef.current.addToast(
  //       "Please Enter Required Fields",
  //       "warning"
  //     );

  //   // If open to auction is selected but creator hasn't made 10 sales
  //   if (formData.open_to_auction && creatorSales < 10) {
  //     return toastRef.current.addToast(
  //       "You need at least 10 sales to start an auction.",
  //       "warning"
  //     );
  //   }

  //   const data = new FormData();
  //   data.append("file", file);
  //   data.append("title", formData.item_title);
  //   data.append("seller", walletAddress);
  //   data.append("walletAddress", walletAddress);
  //   data.append("description", formData.item_desc);
  //   data.append("price", formData.item_price);
  //   data.append("royalties", formData.item_royalties);
  //   data.append("tags", JSON.stringify(tags));
  //   data.append("open_to_offers", formData.open_to_offers);
  //   data.append("open_to_sell", formData.open_to_sell);
  //   data.append("open_to_auction", formData.open_to_auction);
  //   data.append("edition_count", editionCount);
  //   data.append("auction_duration", auctionDuration);
  //   data.append("minimum_bid", formData.minimum_bid);
  //   data.append("open_until", formData.open_until);
  //   data.append("total_supply", formData.total_supply);
  //   data.append("edition_type", formData.edition_type);
  //   try {
  //     setLoading(true);
  //     const response = await axios.post(`${domainpath}/api/art/upload`, data);
  //     console.log(response);

  //     if (response.data.success === true) {
  //       // Loop through the mintedNfts array to handle each NFT
  //       response.data.mintedNfts.forEach(async (nft) => {
  //         const historyData = {
  //           action: "mint",
  //           user: walletAddress,
  //           details: nft.title,
  //           nft_id: nft.nft_id,
  //         };

  //         await createHistory(historyData);
  //       });

  //       // Add a success toast
  //       toastRef.current.addToast("Art uploaded successfully!", "success");
  //       setLoading(false);
  //       navigate("/");
  //     } else {
  //       setLoading(false);
  //       toastRef.current.addToast("Internal Server Error.", "error");
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error uploading file:", error);
  //   }
  // };

  const handleUpload = async () => {
    if (!walletAddress) {
      toastRef.current.addToast("Connect your wallet first.", "warning");
      return;
    }

    if (!file) {
      toastRef.current.addToast("Please select a file first.", "warning");
      return;
    }

    if (!formData.item_title) {
      toastRef.current.addToast("Please enter required fields", "warning");
      return;
    }

    if (formData.open_to_auction && creatorSales < 10) {
      toastRef.current.addToast(
        "You need at least 10 sales to start an auction.",
        "warning"
      );
      return;
    }

    if (!ipfsUrl || !mimeType) {
      toastRef.current.addToast("IPFS URL or MIME type missing", "error");
      return;
    }

    try {
      setLoading(true);

      const creators_json = JSON.stringify([{ address: walletAddress }]);
      const formats_json = JSON.stringify([{ uri: ipfsUrl, mimeType }]);

      const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL);
      tezos.setWalletProvider(wallet); // make sure wallet is connected & set
      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );
      const contractStorage = await contract.storage();
      const tokenIdStart = contractStorage.last_id.toNumber();
      const auctionStart = formData.open_to_auction
        ? Math.floor(
            new Date(formData.auction_start_time || Date.now()).getTime() / 1000
          )
        : 0;

      const auctionEnd = formData.open_to_auction
        ? Math.floor(
            new Date(
              formData.auction_end_time || Date.now() + 86400000
            ).getTime() / 1000
          )
        : 0;

      const minimumBid = formData.open_to_auction
        ? parseFloat(formData.minimum_bid || 0) * 1_000_000
        : 0;

      // Call mint with params in exact order as requested
      const operation = await contract.methods
        .mint(
          walletAddress, // owner
          parseFloat(formData.item_price || 0) * 1_000_000, // price in mutez
          ipfsUrl, // IPFS URL
          formData.nft_type || "image", // nft_type
          formData.open_to_sell,
          formData.open_to_auction,
          formData.open_to_offers,
          formData.item_title,
          formData.item_desc,
          "NFT", // symbol
          tags,
          mimeType,
          creators_json,
          formats_json,
          formData.edition_type || "fixed",
          parseInt(formData.total_supply || 1),
          formData.open_until
            ? Math.floor(new Date(formData.open_until).getTime() / 1000)
            : 0,
          parseInt(formData.total_supply || 1),
          auctionStart,
          auctionEnd,
          minimumBid
        )
        .send();

      toastRef.current.addToast("Creating NFT...", "info");
      await operation.confirmation(1);
      const totalSupply = parseInt(formData.total_supply || 1);

      const tokenIds = [];
      for (let i = 0; i < totalSupply; i++) {
        tokenIds.push(tokenIdStart + i);
      }

      // Create one Art record per tokenId
      for (let tokenId of tokenIds) {
        const artPayload = {
          owner: walletAddress,
          nft_id: tokenId,
          creator: walletAddress,
          price: parseFloat(formData.item_price || 0),
          ipfsUrl,
          nft_type: formData.nft_type || "image",
          open_to_sell: formData.open_to_sell,
          open_to_auction: formData.open_to_auction,
          open_to_offers: formData.open_to_offers,
          title: formData.item_title,
          description: formData.item_desc,
          symbol: "NFT",
          tags,
          mime_type: mimeType,
          creators_json,
          formats_json,
          edition_type: formData.edition_type || "fixed",
          total_supply: totalSupply,
          open_until: formData.open_until
            ? Math.floor(new Date(formData.open_until).getTime() / 1000)
            : 0,
          edition_count_to_mint: parseInt(editionCount || 1),
          auction_start_time: auctionStart,
          auction_end_time: auctionEnd,
          minimum_bid: minimumBid / 1_000_000,
        };

        await axios.post(`${domainpath}/api/art/`, artPayload);
      }

      toastRef.current.addToast("Art records created!", "success");
      navigate("/");
    } catch (error) {
      console.error("Error minting NFT:", error);
      toastRef.current.addToast(
        `Failed to mint NFT: ${error.message}`,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <GlobalStyles />
        {creatorSales >= 10 &&
        !hasClosedModal &&
        showBurnSellModal === false ? (
          <>
            <section className="jumbotron breadcumb no-bg">
              <div className="mainbreadcumb">
                <div className="container">
                  <div className="row m-10-hor">
                    <div className="col-12">
                      <h1 className="text-center">Create</h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="container">
              <div className="row">
                <div className="col-lg-7 offset-lg-1 mb-5 ">
                  <form id="form-create-item" className="form-border">
                    <div className="field-set">
                      <h5 className="mb-1">
                        Upload file <span style={{ color: "red" }}>*</span>
                      </h5>
                      <div className="d-create-file">
                        <p id="file_name">
                          PNG, JPG, GIF, WEBP, MP4 or MP3. Max 500MB.
                        </p>
                        {file && <p>{file.name}</p>}

                        <div className="browse">
                          <input
                            type="button"
                            id="get_file"
                            className="btn-main"
                            value="Browse"
                            onClick={() =>
                              document.getElementById("upload_file").click()
                            }
                          />
                          <input
                            id="upload_file"
                            type="file"
                            accept="image/png, image/jpeg, image/webp, image/gif, video/mp4, audio/mpeg"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                      <div className="spacer-single"></div>
                      <h5 className="mb-1">
                        Title <span style={{ color: "red" }}>*</span>
                      </h5>
                      <input
                        type="text"
                        name="item_title"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="e.g. 'Crypto Funk'"
                      />
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Description</h5>
                      <textarea
                        name="item_desc"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="e.g. 'This is very limited item'"
                      ></textarea>
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Royalties</h5>
                      <input
                        type="number"
                        min={0}
                        name="item_royalties"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Suggested: 0, 10%, 20%, 30%. Maximum is 70%"
                      />{" "}
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">
                        Edition Type <span style={{ color: "red" }}>*</span>
                      </h5>
                      <select
                        name="edition_type"
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="fixed">Fixed</option>
                        <option value="open">Open</option>
                      </select>
                      <div className="spacer-10"></div>
                      {/* Total Supply (Only for Fixed Editions) */}
                      {formData.edition_type === "fixed" && (
                        <>
                          <h5 className="mb-1">
                            Total Supply <span style={{ color: "red" }}>*</span>
                          </h5>
                          <input
                            type="number"
                            min={1}
                            name="total_supply"
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Total number of editions"
                          />
                          <div className="spacer-10"></div>
                        </>
                      )}
                      {/* Minted Count */}
                      {/*<h5 className="mb-1">Minted Count</h5>
                      <input
                        type="number"
                        name="minted_count"
                        value={formData.minted_count || 0}
                        className="form-control"
                        disabled
                      /> */}
                      <div className="spacer-10"></div>
                      {/* Open Until (For Open Editions) */}
                      {formData.edition_type === "open" && (
                        <>
                          <h5 className="mb-1">Open Until</h5>
                          <input
                            type="datetime-local"
                            name="open_until"
                            onChange={handleInputChange}
                            className="form-control"
                          />
                          <div className="spacer-10"></div>
                        </>
                      )}
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Select method</h5>
                      <div className="de_tab tab_methods">
                        <ul className="de_nav">
                          <li
                            id="btn1"
                            className={formData.open_to_sell ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_sell: true,
                                open_to_offers: false,
                                open_to_auction: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-tag"></i>Fixed price
                            </span>
                          </li>
                          <li
                            id="btn2"
                            className={formData.open_to_auction ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_auction: true,
                                open_to_sell: false,
                                open_to_offers: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-hourglass-1"></i>Timed auction
                            </span>
                          </li>
                          <li
                            id="btn3"
                            className={formData.open_to_offers ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_offers: true,
                                open_to_sell: false,
                                open_to_auction: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-users"></i>Open for bids
                            </span>
                          </li>
                        </ul>
                      </div>
                      {formData.open_to_auction && creatorSales >= 10 ? (
                        <>
                          <div className="spacer-10"></div>
                          <h5 className="mb-1">Auction Time Range</h5>
                          <div className="row flex">
                            <div className="col-md-4">
                              <label>Start Time</label>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={auctionStartTime}
                                onChange={(e) =>
                                  handleAuctionTimeChange(e, "start")
                                }
                                min={new Date().toISOString().slice(0, 16)} // prevents past dates
                              />
                            </div>
                            <div className="col-md-4">
                              <label>End Time</label>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={auctionEndTime}
                                onChange={(e) =>
                                  handleAuctionTimeChange(e, "end")
                                }
                                min={new Date().toISOString().slice(0, 16)} // prevents past dates
                              />
                            </div>
                            <div className="col-md-4">
                              <label>Minimum Bid (XTZ)</label>
                              <input
                                type="number"
                                name="minimum_bid"
                                className="form-control"
                                value={formData.minimum_bid}
                                onChange={handleInputChange}
                                min="0"
                                step="0.01"
                                placeholder="Enter minimum bid in XTZ"
                              />
                            </div>
                          </div>

                          {!auctionValidation.isValid && (
                            <div className="text-danger mt-2">
                              {auctionValidation.message}
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {formData.open_to_sell && (
                        <>
                          <div className="spacer-10"></div>
                          <h5 className="mb-1">Price</h5>
                          <input
                            type="number"
                            min={0}
                            name="item_price"
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Enter price for one item (ꜩ)"
                          />
                        </>
                      )}
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Tags</h5>
                      <div className="tags-input-wrapper mt-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tags and press Enter"
                          value={tagInput}
                          onChange={(e) => setTagInput(e.target.value)}
                          onKeyDown={handleTagKeyDown}
                        />
                        <div className="tags-list">
                          {tags.map((tag, index) => (
                            <span key={index} className="tag">
                              {tag}
                              <span
                                className="remove-tag"
                                onClick={() => removeTag(index)}
                              >
                                &times;
                              </span>
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="spacer-10"></div>
                      <input
                        type="button"
                        id="submit"
                        className="btn-main"
                        value="Create Item"
                        onClick={handleUpload}
                      />
                    </div>
                  </form>
                </div>

                <div className="col-lg-3 col-sm-6 col-xs-12">
                  <h5 style={{ margin: "13px 0 5px 0" }}>Preview item</h5>
                  <div className="nft__item m-0">
                    <div className="author_list_pp">
                      <span>
                        <img
                          className="lazy"
                          src={profileImage || "./img/author/author-1.jpg"}
                          alt=""
                        />
                        <i className="fa fa-check"></i>
                      </span>
                    </div>
                    <div className="nft__item_first ">
                      <div
                        className={
                          file?.type?.startsWith("audio/")
                            ? "music_nft nft__item_wrap aspect-square group"
                            : "nft__item_wrap"
                        }
                      >
                        <span>
                          {previewUrl ? (
                            <>
                              {file?.type?.startsWith("image/") ? (
                                <img
                                  src={previewUrl}
                                  className="lazy nft__item_preview"
                                  alt="NFT"
                                  // style={{ width: "100%", height: "auto" }}
                                />
                              ) : file?.type?.startsWith("video/") ? (
                                <video
                                  src={previewUrl}
                                  className="lazy nft__item_preview"
                                  controls
                                  //style={{ width: "100%", height: "auto" }}
                                />
                              ) : file?.type?.startsWith("audio/") ? (
                                <audio
                                  src={previewUrl}
                                  controls
                                  style={{ width: "90%", margin: "0 auto" }}
                                />
                              ) : (
                                <p>Unsupported media format</p>
                              )}
                            </>
                          ) : (
                            <img
                              src="./img/items/dummy.jpg"
                              className="lazy nft__item_preview"
                              alt="NFT"
                              // style={{ width: "100%", height: "auto" }}
                            />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="nft__item_info">
                      <span>
                        <h4>{formData.item_title || "Pinky Ocean"}</h4>
                      </span>
                      <div className="nft__item_price">
                        {!formData.open_to_offers
                          ? `${formData.item_price + "ꜩ"}`
                          : "Open to Offers"}
                      </div>
                      {/* <div className="nft__item_price">
                     {formData.open_to_sell
                       ? `${formData.item_price || 0.0} ꜩ`
                       : formData.open_to_auction
                       ? "Auction"
                       : "Not for sale"}
                   </div> */}
                      {editionCount > 1 && (
                        <div className="nft__item_edition">
                          Edition: {editionCount}
                        </div>
                      )}
                      <div className="nft__item_action">
                        <span>{formData.item_desc || ""}</span>
                      </div>
                      <div className="nft__item_like">
                        <i className="fa fa-heart"></i>
                        <span>{formData.item_likes || 0}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : userNFTs.length === 0 ||
          (creatorSales > 10 && showBurnSellModal === false) ? (
          <>
            <section className="jumbotron breadcumb no-bg ">
              <div className="mainbreadcumb">
                <div className="container">
                  <div className="row m-10-hor">
                    <div className="col-12">
                      <h1 className="text-center">Create</h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="container  create-page-custom-style">
              <div className="row  create-page-mobile-style">
                <div className="col-lg-7 offset-lg-1 mb-5 ">
                  <form id="form-create-item" className="form-border">
                    <div className="field-set">
                      <h5 className="mb-1">
                        Upload file <span style={{ color: "red" }}>*</span>
                      </h5>
                      <div className="d-create-file">
                        <p id="file_name">
                          PNG, JPG, GIF, WEBP, MP4 or MP3. Max 500MB.
                        </p>
                        {file && <p>{file.name}</p>}

                        <div className="browse">
                          <input
                            type="button"
                            id="get_file"
                            className="btn-main"
                            value="Browse"
                            onClick={() =>
                              document.getElementById("upload_file").click()
                            }
                          />
                          <input
                            id="upload_file"
                            type="file"
                            accept="image/png, image/jpeg, image/webp, image/gif, video/mp4, audio/mpeg"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                      <div className="spacer-single"></div>
                      <h5 className="mb-1">
                        Title <span style={{ color: "red" }}>*</span>
                      </h5>
                      <input
                        type="text"
                        name="item_title"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="e.g. 'Crypto Funk'"
                      />
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Description</h5>
                      <textarea
                        name="item_desc"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="e.g. 'This is very limited item'"
                      ></textarea>
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Royalties</h5>
                      <input
                        type="number"
                        min={0}
                        name="item_royalties"
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Suggested: 0, 10%, 20%, 30%. Maximum is 70%"
                      />{" "}
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">
                        Edition Type <span style={{ color: "red" }}>*</span>
                      </h5>
                      <select
                        name="edition_type"
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="fixed">Fixed</option>
                        <option value="open">Open</option>
                      </select>
                      <div className="spacer-10"></div>
                      {/* Total Supply (Only for Fixed Editions) */}
                      {formData.edition_type === "fixed" && (
                        <>
                          <h5 className="mb-1">
                            Total Supply <span style={{ color: "red" }}>*</span>
                          </h5>
                          <input
                            type="number"
                            min={1}
                            name="total_supply"
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Total number of editions"
                          />
                          <div className="spacer-10"></div>
                        </>
                      )}
                      <div className="spacer-10"></div>
                      {/* Open Until (For Open Editions) */}
                      {formData.edition_type === "open" && (
                        <>
                          <h5 className="mb-1">Open Until</h5>
                          <input
                            type="datetime-local"
                            name="open_until"
                            onChange={handleInputChange}
                            className="form-control"
                          />
                          <div className="spacer-10"></div>
                        </>
                      )}
                      <h5 className="mb-1">Select method</h5>
                      <div className="de_tab tab_methods">
                        <ul className="de_nav">
                          <li
                            id="btn1"
                            className={formData.open_to_sell ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_sell: true,
                                open_to_offers: false,
                                open_to_auction: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-tag"></i>Fixed price
                            </span>
                          </li>
                          <li
                            id="btn2"
                            className={formData.open_to_auction ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_auction: true,
                                open_to_sell: false,
                                open_to_offers: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-hourglass-1"></i>Timed auction
                            </span>
                          </li>
                          <li
                            id="btn3"
                            className={formData.open_to_offers ? "active" : ""}
                            onClick={() =>
                              setFormData((prevData) => ({
                                ...prevData,
                                open_to_offers: true,
                                open_to_sell: false,
                                open_to_auction: false,
                              }))
                            }
                          >
                            <span>
                              <i className="fa fa-users"></i>Open for bids
                            </span>
                          </li>
                        </ul>
                      </div>
                      {formData.open_to_auction && creatorSales >= 10 ? (
                        <>
                          <div className="spacer-10"></div>
                          <h5 className="mb-1">Auction Time Range</h5>
                          <div className="row flex">
                            <div className="col-md-4">
                              <label>Start Time</label>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={auctionStartTime}
                                onChange={(e) =>
                                  handleAuctionTimeChange(e, "start")
                                }
                                min={new Date().toISOString().slice(0, 16)} // prevents past dates
                              />
                            </div>
                            <div className="col-md-4">
                              <label>End Time</label>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={auctionEndTime}
                                onChange={(e) =>
                                  handleAuctionTimeChange(e, "end")
                                }
                                min={new Date().toISOString().slice(0, 16)} // prevents past dates
                              />
                            </div>
                            <div className="col-md-4">
                              <label>Minimum Bid (XTZ)</label>
                              <input
                                type="number"
                                name="minimum_bid"
                                className="form-control"
                                value={formData.minimum_bid}
                                onChange={handleInputChange}
                                min="0"
                                step="0.01"
                                placeholder="Enter minimum bid in XTZ"
                              />
                            </div>
                          </div>

                          {!auctionValidation.isValid && (
                            <div className="text-danger mt-2">
                              {auctionValidation.message}
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {formData.open_to_sell && (
                        <>
                          <div className="spacer-10"></div>
                          <h5 className="mb-1">Price</h5>
                          <input
                            type="number"
                            min={0}
                            name="item_price"
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Enter price for one item (ꜩ)"
                          />
                        </>
                      )}
                      <div className="spacer-10"></div>
                      <h5 className="mb-1">Tags</h5>
                      <div className="tags-input-wrapper mt-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tags and press Enter"
                          value={tagInput}
                          onChange={(e) => setTagInput(e.target.value)}
                          onKeyDown={handleTagKeyDown}
                        />
                        <div className="tags-list">
                          {tags.map((tag, index) => (
                            <span key={index} className="tag">
                              {tag}
                              <span
                                className="remove-tag"
                                onClick={() => removeTag(index)}
                              >
                                &times;
                              </span>
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="spacer-10"></div>
                      <input
                        type="button"
                        id="submit"
                        className="btn-main"
                        value="Create Item"
                        onClick={handleUpload}
                      />
                    </div>
                  </form>
                </div>

                <div className="col-lg-3 col-sm-7 col-xs-12">
                  <h5 className="mb-1">Preview item</h5>
                  <div className="nft__item m-0">
                    <div className="author_list_pp">
                      <span>
                        <img
                          className="lazy"
                          src={profileImage || "./img/author/author-1.jpg"}
                          alt=""
                        />
                        <i className="fa fa-check"></i>
                      </span>
                    </div>
                    <div className="nft__item_first ">
                      <div
                        className={
                          file?.type?.startsWith("audio/")
                            ? "music_nft nft__item_wrap"
                            : "nft__item_wrap"
                        }
                      >
                        <span>
                          {previewUrl ? (
                            <>
                              {file?.type?.startsWith("image/") ? (
                                <img
                                  src={previewUrl}
                                  className="lazy nft__item_preview"
                                  alt="NFT"
                                  // style={{ width: "100%", height: "auto" }}
                                />
                              ) : file?.type?.startsWith("video/") ? (
                                <video
                                  src={previewUrl}
                                  className="lazy nft__item_preview"
                                  controls
                                  //style={{ width: "100%", height: "auto" }}
                                />
                              ) : file?.type?.startsWith("audio/") ? (
                                <audio
                                  src={previewUrl}
                                  controls
                                  style={{ width: "90%", margin: "0 auto" }}
                                />
                              ) : (
                                <p>Unsupported media format</p>
                              )}
                            </>
                          ) : (
                            <img
                              src="./img/items/dummy.jpg"
                              className="lazy nft__item_preview"
                              alt="NFT"
                              // style={{ width: "100%", height: "auto" }}
                            />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="nft__item_info">
                      <span>
                        <h4>{formData.item_title || "Pinky Ocean"}</h4>
                      </span>
                      <div className="nft__item_price">
                        {!formData.open_to_offers
                          ? `${formData.item_price + "ꜩ"}`
                          : "Open to Offers"}
                      </div>
                      {/* <div className="nft__item_price">
                     {formData.open_to_sell
                       ? `${formData.item_price || 0.0} ꜩ`
                       : formData.open_to_auction
                       ? "Auction"
                       : "Not for sale"}
                   </div> */}
                      {editionCount > 1 && (
                        <div className="nft__item_edition">
                          Edition: {editionCount}
                        </div>
                      )}
                      <div className="nft__item_action">
                        <span>{formData.item_desc || ""}</span>
                      </div>
                      <div className="nft__item_like">
                        <i className="fa fa-heart"></i>
                        <span>{formData.item_likes || 0}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <div className="modal-overlay">
            <div className="modal-content">
              {/* <button
                onClick={() => setShowBurnSellModal(false)}
                className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
              >
                ✖
              </button> */}
              <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-6 rounded-lg shadow-md animate-fade-in">
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="text-xl font-semibold flex items-center gap-2">
                    <svg
                      className="w-6 h-6 text-yellow-500"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 16h-1v-4h-1m1-4h.01M12 20h.01M4.93 4.93l1.414 1.414M19.07 4.93l-1.414 1.414M4.93 19.07l1.414-1.414M19.07 19.07l-1.414-1.414"
                      />
                    </svg>
                    Creation Paused
                  </div>
                  <p className="text-sm md:text-base text-gray-700 max-w-sm">
                    You've reached the limit — either{" "}
                    <strong>burn your current art</strong> or
                    <strong> celebrate 10 sales</strong> to craft a new
                    masterpiece.
                  </p>
                  <button
                    className="bg-black text-white px-5 py-2 rounded-md hover:bg-gray-800 transition duration-300 font-semibold"
                    onClick={() => handleBurnNFT(userNFTs[0]?.key)}
                  >
                    🔥 Burn NFT
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};

export default Createpage;
